// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Rr-z","tooltipWrapper":"Sr-z","icon":"Tr-z","tooltip":"Ur-z","content":"Vr-z"};